import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getNamePlacement } from '../thunks/placementThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPlacementKey } from '../thunkKeys/placementThunksKeys';

const SLICE_NAME = 'namePlacement';

export const namePlacementSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearNamePlacement(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getNamePlacement });
        builder.addCase(
            clearPlacementKey,
            () => commonInitialState,
        );
    },
});

export const { clearNamePlacement } = namePlacementSlice.actions;

export const namePlacement = namePlacementSlice.reducer;
